















































import CCategoryPicker from '~/components/shared/configurable/category/picker/CCategoryPicker.vue'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import CCategorySearch from '~/components/shared/configurable/category/CCategorySearch.vue'
import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useNamespacedStore } from '~/compositions/store'
import { FieldChange } from '~/models/form/types'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { ciThreeDots } from '~/icons/source/regular/message-dots'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { Ref } from '@vue/composition-api'
import { ciGearboxAuto } from '~/icons/source/regular/gearbox-auto'
import { ciGearboxSemiAuto } from '~/icons/source/regular/gearbox-semi-auto'
import { ciGearboxManual } from '~/icons/source/regular/gearbox-manual'
import { ciDriveType4wd } from '~/icons/source/regular/drive-type-4wd'
import { ciDriveTypeRwd } from '~/icons/source/regular/drive-type-rwd'
import { ciDriveTypeFwd } from '~/icons/source/regular/drive-type-fwd'
export default defineComponent({
  components: {
    CFormError,
    CConfirmationModal,
    CCategoryPicker,
    CCategorySearch
  },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const selectedValue = ref<number | null>(null)

    function onValue(v: Ref) {
      if (Array.isArray(v.value)) {
        selectedValue.value = v.value.length ? v.value[0] : null
      } else {
        selectedValue.value = v.value || null
      }
    }

    const { valuesChanged, error } = useClassifiedForm(props, {
      onValue
    })

    const { state } = useNamespacedStore<FormState>(CLASSIFIED_FORM_NS)

    const schemaExtras = computed(() => state.extras)

    const handleOptionSelect = (categoryId: number) => {
      selectedValue.value = categoryId
      emitChanges()
    }

    const getIconForValue = (value: any) => {
      switch (value) {
        case 'automatic':
          return ciGearboxAuto
        case 'semiauto':
          return ciGearboxSemiAuto
        case 'manual':
          return ciGearboxManual
        case '4x4':
        case 'AWD':
          return ciDriveType4wd
        case 'RWD':
          return ciDriveTypeRwd
        case 'FWD':
          return ciDriveTypeFwd
        default:
          return null
      }
    }
    const getIconClassForValue = (value: any) => {
      switch (value) {
        case 'automatic':
        case 'semiauto':
        case 'manual':
          return '!tw-w-[2.625rem]'
        case '4x4':
        case 'AWD':
        case 'RWD':
        case 'FWD':
          return '!tw-w-[2.125rem]'
        default:
          return '!tw-w-5'
      }
    }

    const options = computed(
      () =>
        specs.value?.values?.map(o => {
          return {
            ...o,
            icon: getIconForValue(o.value),
            iconClass: getIconClassForValue(o.value)
          }
        }) || []
    )

    const emitChanges = () => {
      const categoryRelatedChanges: FieldChange[] = [
        {
          name: name.value,
          value: selectedValue.value
        }
      ]

      valuesChanged(categoryRelatedChanges)
    }

    return {
      selectedValue,
      handleOptionSelect,
      error,
      schemaExtras,
      ciThreeDots,
      options
    }
  }
})
